import { connect } from "react-redux";
import {
  selectCutoutSize,
  selectCutoutPosition,
  selectModalCutoutPosition,
  selectModalCutoutSize,
  setCutoutSize,
  setCutoutPosition,
  setModalCutoutPosition,
  setModalCutoutSize
} from "~/store/ducks/user/uistate";

import Cutout from "./Cutout";

function mapStateToProps(state) {
  return {
    cutoutSize: selectCutoutSize(state),
    cutoutPosition: selectCutoutPosition(state),
    modalCutoutSize: selectModalCutoutSize(state),
    modalCutoutPosition: selectModalCutoutPosition(state)
  };
}

const mapDispatchToProps = {
  setCutoutSize,
  setCutoutPosition,
  setModalCutoutPosition,
  setModalCutoutSize
};

export default connect(mapStateToProps, mapDispatchToProps)(Cutout);
